/**
 * Created by mcochrane on 22/06/17.
 */

import marked from 'marked'
import {
  updateComponentScriptsInDOM,
  compileComponent,
  // resetAllComponentInstances,
  getAllComponentInstances,
  findComponent,
  deleteComponent
  // setCurrentComponentInstances
} from './components'
import { loadCustomScriptsFromComponentDefs } from './customScripts'
import { mapNewToOldIndex, stringdiff } from './stringdiff'
import _ from 'lodash'

var _oldInputString = ''

/**
 * Checks if a component in componentDefs matches matchString and if it does, checks if the component exists already,
 * if it exists already it returns that component, if not, it creates a new component and returns that.
 * @param componentDefs     a list of component definitions
 * @param matchString       the string that was already matched to *a* component definition (but
 *                          we don't know which one yet)
 * @param offset
 * @param diffs
 * @param note
 * @param newCmpInsts
 */
function checkForMatch (componentDefs, matchString, offset, diffs, note, newCmpInsts, saveFunc) {
  var newCmpInst = null
  componentDefs.some(function (cdef) {
    let re = new RegExp(cdef.md, 'g')
    // Max of 10 submatches...
    let result = matchString.replace(re, function (match, a1, a2, a3, a4, a5, a6, a7, a8, a9, a10) {
      let allA = [a1, a2, a3, a4, a5, a6, a7, a8, a9, a10]
      let subMatches = []
      let matchIndex = -1
      allA.every(function (a) {
        if (typeof a === 'number') {
          matchIndex = a
          return false
        }
        subMatches.push(a)
        return true
      })

      // If we match a 'subcomopnent' don't replace anything!
      if (matchIndex !== 0) return match

      matchIndex += offset

      // Check if it's within another component we've found so far.
      var isWithin = false
      newCmpInsts.every(function (cmp) {
        if (matchIndex >= cmp.mdIndex && (matchIndex + match.length) <= cmp.mdIndex + cmp.md.length) {
          isWithin = true
          return false
        }
        return true
      })
      if (isWithin) return ''

      let oldMatchIndex = mapNewToOldIndex(matchIndex, diffs)
      if (oldMatchIndex === null) {
        newCmpInst = compileComponent(cdef, match, matchIndex, note, subMatches, saveFunc)
        return ''
      } else {
        let foundcmp = findComponent(match, oldMatchIndex, cdef.type)
        if (foundcmp !== null) {
          // found it!
          // Set to new location!
          foundcmp.setMdIndex(matchIndex)
          newCmpInst = foundcmp
          return ''
        } else {
          newCmpInst = compileComponent(cdef, match, matchIndex, note, subMatches, saveFunc)
          return ''
        }
      }
    })
    // In the code above we replace the match (which should be the entire string) with ""
    // So if result is "" then we successfully found a match!
    if (result === '') return true // return true to 'break' out of 'some'
  })
  return newCmpInst
}

function makeCombinedRegexFromCmpDefs (componentDefs) {
  let combinedRegex = ''
  componentDefs.forEach(function (cmpnt) {
    combinedRegex += '(' + cmpnt.md + ')|'
  })
  combinedRegex = combinedRegex.substr(0, combinedRegex.length - 1)

  if (combinedRegex === '') return null

  return new RegExp(combinedRegex, 'g')
}

export function resetCustomMd () {
  _oldInputString = ''
}

/**
 * Parses an input string and replaces all custom component regex matches with
 * the custom component's html placeholder.  Also adds custom javascript and css to the
 * DOM.
 * Also processes the input string as markdown.
 * This function clears any existing javascript/css from previous runs before
 * executing.
 * @param inputStr              a string to process
 * @param componentDefs         a list of ComponentDefinitions to process.  If
 *                              this is not passed or is null then the global
 *                              component definitions will be used.
 * @param note                  the note object that the markdown comes from.
 * @param editorCursor
 * @param reloadCustomScripts   if true all custom scripts will be reloaded.
 * @param saveFunc              a function used to save the note if changes are made (should probably be throttled)
 */
export function updateCustomMd (inputStr, componentDefs, note = null, editorCursor = null, reloadCustomScripts = false, saveFunc = null) {
  // List of not found components, if we don't find them then they don't exist any more and can be deleted
  // Start by saying all components should be deleted, then we'll remove them from this list as we find them in the doc.
  let cmpsToDelete = getAllComponentInstances().slice(0)

  if (editorCursor !== null) {
    inputStr = inputStr.substr(0, editorCursor) + '<span class="editorCursor"></span>' +
      inputStr.substr(editorCursor, inputStr.length - editorCursor)
  }

  let diffs = stringdiff(_oldInputString, inputStr)
  _oldInputString = inputStr

  loadCustomScriptsFromComponentDefs(componentDefs, reloadCustomScripts ? 'force' : 'contents')

  let newCmpInsts = []

  let componentsReplacedInputStr = inputStr
  let re = makeCombinedRegexFromCmpDefs(componentDefs)
  if (re !== null) {
    componentsReplacedInputStr = inputStr.replace(re, (...args) => {
      // Gets called once per regex match - that's a match of *any* regex from any component we have.
      let match = args[0]
      let offset = args[args.length - 2]
      let newCmpInst = checkForMatch(componentDefs, match, offset, diffs, note, newCmpInsts, saveFunc)
      if (newCmpInst === null) {
        console.warn('Regex match: ' + match + 'but then couldn\'t find a component that matches it?!')
        return ''
      } else {
        if (newCmpInst.isInDOM()) {
          // Remove from 'cmpsToDelete'
          _.remove(cmpsToDelete, c => {
            return c === newCmpInst
          })
        }
        newCmpInsts.push(newCmpInst)
        return newCmpInst.genHtmlPlaceholder()
      }
    })
  }

  // Delete any components we didn't find in the markdown.
  cmpsToDelete.forEach(cmp => {
    deleteComponent(cmp)
  })

  updateComponentScriptsInDOM()

  // Apply the markdown after doing other parsing.
  return marked(componentsReplacedInputStr || '')
}
